import React from "react";
import "./CampaignOverview.scss";
import GeoView from "../GeoView/GeoView";
import { campaignTypeName, categoryGroupNames } from "../../constants";
import moment from "moment";

function renderValue(val) {
  return val || "-";
}

function renderShowType(info) {
  const types = [];

  if (info.show_in_top) {
    types.push("Топ");
  }

  if (info.show_in_inf) {
    types.push("Инф");
  }

  return types.join("+") || "-";
}

function renderDevice(devices) {
  if (devices == undefined) {
    return "-";
  }

  if (devices.length == 0) {
    return "Все";
  }

  const code2name = {
    TABLET: "Таб",
    MOBILE: "Моб",
    PC: "Деск"
  };

  const names = devices.map(device => code2name[device]);

  return names.join(", ");
}

function renderUpdated(updated) {
  if (updated) {
    return moment(updated).format("DD/MM/YY (HH:mm)");
  }

  return "-";
}

function getShowArea(categoryGroup = []) {
  return categoryGroup.map(gid => categoryGroupNames[gid] || "-").join(",");
}

const CampaignOverview = ({ info }) => {
  const typeName = campaignTypeName[info.type];

  return (
    <div className="campaign-overview">
      <div className="campaign-overview__meta first">
        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">Устройства</span>
          <span className="campaign-overview__meta-value">
            {renderDevice(info.devices)}
          </span>
        </div>
        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">Активные</span>
          <span className="campaign-overview__meta-value">
            {renderValue(info.active_teasers)}
          </span>
        </div>
        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">Обновление</span>
          <span className="campaign-overview__meta-value">
            {renderUpdated(info.updated_at)}
          </span>
        </div>
        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">Долг</span>
          <span className="campaign-overview__meta-value">
            {renderValue(info.debt)}%
          </span>
        </div>
        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">Автостарт тизеров</span>
          <span className="campaign-overview__meta-value">
            {info?.teaser_autostart ? "Да" : "Нет"}
          </span>
        </div>
      </div>

      <div className="campaign-overview__meta">
        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">Тип кампании</span>
          <span className="campaign-overview__meta-value">
            {renderValue(typeName)}
          </span>
        </div>

        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">Обасть показа</span>
          <span className="campaign-overview__meta-value">
            {getShowArea(info.category_group)}
          </span>
        </div>
        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">Где показываем</span>
          <span className="campaign-overview__meta-value">
            {renderShowType(info)}
          </span>
        </div>
        <div className="campaign-overview__meta-row">
          <span className="campaign-overview__meta-key">География</span>
          <span className="campaign-overview__meta-value">
            <GeoView geo={info.geo} isExclude={info.geo_exclude} />
          </span>
        </div>
      </div>
    </div>
  );
};

CampaignOverview.defaultProps = {
  info: {}
};

export default CampaignOverview;
